import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { getSidebarItems, mediaUrl } from '../api';



const items = [
  { to: '/', labelKey: 'common.menu', icon: 'fa-solid fa-house' },
  { to: '/favorites', labelKey: 'common.myFavorites', icon: 'fa-solid fa-star' },
  { to: '/articles', labelKey: 'articlesPage.title', icon: 'fa-solid fa-newspaper' },

];

function Sidebar({ isClosed, onToggle, onNavigate, extraItems = [], canManageArticles = false, canManageNews = false }) {
  const { t } = useTranslation();

  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    async function loadSidebarItems() {
      try {
        const data = await getSidebarItems();
        setSidebarItems(data);
      } catch (error) {
        console.error('Failed to load sidebar items:', error);
      }
    }

    // Load sidebar items when the component is mounted
    // Sidebar-Elemente laden, wenn die Komponente eingebunden wird
    loadSidebarItems();

    // Reload the sidebar when an item is created, updated, or deleted
    // Sidebar neu laden, wenn ein Element erstellt, geändert oder gelöscht wurd
    const handleSidebarUpdated = () => {
      loadSidebarItems();
    };

    window.addEventListener(
      'sidebar-updated',
      handleSidebarUpdated
    );
    return () => {
      window.removeEventListener(
        'sidebar-updated',
        handleSidebarUpdated
      );
    };
    
  }, []);

  const bottomItems = [
    { to: '/about', labelKey: 'common.about', icon: 'fa-solid fa-circle-info' },
  ];

  // A link chosen in the sidebar - the current page's too - tells the layout,
  // which closes the sidebar where it lies over the page (a phone).
  const handleClick = (event) => {
    if (onNavigate && event.target.closest('a')) onNavigate();
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <aside className="sidebar" onClick={handleClick}>
      <button
        className="collapse"
        type="button"
        onClick={onToggle}
        aria-label={isClosed ? t('sidebar.expandAriaLabel') :
          t('sidebar.collapseAriaLabel')}>
        ‹
      </button>

      <div className="sidebar-content">

        {items.map((item) => (
          <React.Fragment key={item.to}>
            <NavLink
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `navitem${isActive ? ' active-menu' : ''}`
              }
            >
              <i className={item.icon} />

              <span className="navtext">
                {t(item.labelKey)}
              </span>
            </NavLink>

            {item.to === '/favorites' && (canManageArticles || canManageNews) && (
              <NavLink
                to="/my-articles"
                className={({ isActive }) =>
                  `navitem${isActive ? ' active-menu' : ''}`
                }
              >
                <i className="fa-solid fa-pen-to-square" />
                <span className="navtext">
                  {t('articlesPage.myArticles')}
                </span>
              </NavLink>
            )}

            {item.to === '/articles' && (
              <>
                <NavLink
                  to="/news"
                  className={({ isActive }) =>
                    `navitem${isActive ? ' active-menu' : ''}`
                  }
                >
                  <i className="fa-solid fa-bullhorn" />
                  <span className="navtext">
                    {t('common.companyNews')}
                  </span>
                </NavLink>

                {(canManageArticles || canManageNews) && (
                  <NavLink
                    to="/create-article"
                    className={({ isActive }) =>
                      `navitem${isActive ? ' active-menu' : ''}`
                    }
                  >
                    <i className="fa-solid fa-pen-to-square" />
                    <span className="navtext">
                      {t('common.createContent')}
                    </span>
                  </NavLink>
                )}

                {(canManageArticles || canManageNews) && (
                  <NavLink
                    to="/archive"
                    className={({ isActive }) =>
                      `navitem${isActive ? ' active-menu' : ''}`
                    }
                  >
                    <i className="fa-solid fa-trash" />
                    <span className="navtext">
                      {t('common.trash')}
                    </span>
                  </NavLink>
                )}
                <div className="divider" />
              </>
            )}
          </React.Fragment>
        ))}

        {extraItems.length > 0 && (
          <div className="divider" />
        )}

        {extraItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `navitem${isActive ? ' active-menu' : ''}`
            }
          >
            <i className={item.icon} />
            <span className="navtext">
              {item.label}
            </span>
          </NavLink>
        ))}

        {sidebarItems.map((item) => (
          <NavLink
            key={item.sidebar_item_id}
            to={`/sidebar/${item.sidebar_item_id}`}
            className={({ isActive }) =>
              `navitem${isActive ? ' active-menu' : ''}`
            }
          >
            {item.icon_url && (
              <img
                src={mediaUrl(item.icon_url)}
                alt=""
                className="sidebar-custom-icon"
              />
            )}

            <span className="navtext">
              {item.title}
            </span>
          </NavLink>
        ))}
      </div>

      <div className="sidebar-bottom">
        {bottomItems.map((item) => (
          <NavLink key={item.to} to={item.to} className={({ isActive }) => `navitem${isActive ? ' active-menu' : ''}`}>
            <i className={item.icon} />
            <span className="navtext">{t(item.labelKey)}</span>
          </NavLink>
        ))}
      </div>
    </aside>
  );
}

export default Sidebar;
